var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_c('Hero'),_c('main',{attrs:{"id":"main"}},[_c('About'),_c('Clients'),_c('Counts'),_c('CTA'),_c('Services')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }